import { authRoles } from "../../../auth/authRoles";
import Data from "./Data/Data";
import DetailData from "./Data/DetailData";
import EditData from "./Data/EditData";
import TambahData from "./Data/TambahData";
import EditTipe from "./Tipe/EditTipe";
import TambahTipe from "./Tipe/TambahTipe";
import Tipe from "./Tipe/Tipe";

const asetInvestasiRoutes = [
  {
    path: "/tipe_aset/edit/:id",
    exact: true,
    component: EditTipe,
    auth: authRoles.all,
  },
  {
    path: "/tipe_aset/tambah",
    exact: true,
    component: TambahTipe,
    auth: authRoles.all,
  },
  {
    path: "/tipe_aset",
    exact: true,
    component: Tipe,
    auth: authRoles.all,
  },
  {
    path: "/data_aset/detail/:id",
    exact: true,
    component: DetailData,
    auth: authRoles.all,
  },
  {
    path: "/data_aset/edit/:id",
    exact: true,
    component: EditData,
    auth: authRoles.all,
  },
  {
    path: "/data_aset/tambah",
    exact: true,
    component: TambahData,
    auth: authRoles.all,
  },
  {
    path: "/data_aset",
    exact: true,
    component: Data,
    auth: authRoles.all,
  },
];

export default asetInvestasiRoutes;
